<template>
    <div class="px-6 surface-overlay relative">

        <ul class="list-none p-3 m-0 surface-card flex align-items-center font-medium overflow-x-auto">
            <li class="px-1">
                <a class="cursor-pointer text-900 white-space-nowrap">IsoEvolve</a>
            </li>
            <li class="px-1">
                <i class="pi pi-angle-right text-900"></i>
            </li>
            <li class="px-1">
                <a class="cursor-pointer text-teal-500 white-space-nowrap">Forms</a>
            </li>
        </ul>
    </div>
</template>

<script>

export default {

};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
